import { Controller } from 'stimulus';
import { loadVideoJs, loadVideoCSS } from '../helpers/videoLibrary';

class AudioPlayerController extends Controller {
  connect() {
    this.player = null;

    this.element.style.opacity = 0;

    loadVideoJs().then((module) => {
      loadVideoCSS().then(() => {
        const Plyr = module.default;

        this.player = new Plyr(this.element.querySelector('audio'), {
          controls: [],
        });

        this.player.on('timeupdate', this.onProgress.bind(this));
        this.player.on('play', this.onPlay.bind(this));
        this.player.on('pause', this.onPause.bind(this));

        this.calculateTimelineWidth();

        this.element.style.opacity = 1;
      });
    });
  }

  onTogglePlay() {
    this.player.togglePlay();
  }

  onWindowResize() {
    this.calculateTimelineWidth();
  }

  onProgress() {
    this.setProgressInTimeline(this.player.currentTime / this.player.duration);
  }

  onPlay() {
    this.setButtonState('playing');
  }

  onPause() {
    this.setButtonState('paused');
  }

  onTimelineClick(event) {
    const timelineWidth = this.timelineTarget.offsetWidth;
    const progress = event.offsetX / timelineWidth;

    this.player.currentTime = progress * this.player.duration;
    this.setProgressInTimeline(progress);
  }

  setButtonState(state) {
    this.toggleButtonIconTarget.classList.remove('is-playing');
    this.toggleButtonIconTarget.classList.remove('is-paused');

    this.toggleButtonIconTarget.classList.add(`is-${state}`);
  }

  setProgressInTimeline(progress) {
    this.walkerTarget.style.width = `${(progress * 100)}%`;
  }

  calculateTimelineWidth() {
    const timelineParent = this.timelineTarget.parentNode;
    const parentWidth = timelineParent.offsetWidth;
    const spaceToRemove = parentWidth % 16;

    this.timelineTarget.style.width = `${parentWidth - spaceToRemove}px`;
  }
}

AudioPlayerController.targets = [
  'timeline',
  'walker',
  'toggleButtonIcon',
];

export default AudioPlayerController;
